export const LOGO_RESERVED_WORDS = [
  'app',
  'helix',
  'helixre',
  'localhost',
];
